import io from 'socket.io-client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { BACKEND_URL } from '@/utils/constants';

export const socket = io(BACKEND_URL, {
    // export const socket = io('/', {
    path: '/api/socket.io',
    reconnectionDelayMax: 10000,
    transportOptions: {
        polling: {
            extraHeaders: {
                'Access-Control-Allow-Origin': '*',
            },
        },
    },
});

export function useTracker() {
    const pathname = usePathname();

    // Single source of truth: emit whenever the resolved pathname changes.
    // The previous implementation also attached a `routeChangeComplete`
    // listener OUTSIDE of useEffect, which accumulated a new listener on
    // every render — by the time the user clicked a link the same
    // `activePage` was emitted N times, showing as duplicated pages in
    // the admin's online-users panel.
    useEffect(() => {
        if (!pathname) return;
        socket.emit('activePage', pathname);
    }, [pathname]);

    // Reconnects (after sleep / network blip) reset socket-side state on
    // the server — push the current page again so the admin doesn't keep
    // showing a stale route. Listener is set up once and cleaned up on
    // unmount, so no accumulation.
    useEffect(() => {
        const onConnect = () => {
            if (pathname) socket.emit('activePage', pathname);
        };
        socket.on('connect', onConnect);
        return () => {
            socket.off('connect', onConnect);
        };
    }, [pathname]);

}

export async function useSubscription(channel: string, dataHandler: (...args: any[]) => void) {
    useEffect(() => {
        socket.on(channel, dataHandler);
        return () => {
            socket.off(channel, dataHandler);
        };
    }, [socket]);
}
